<div class="image-container">
    <image-with-artifacts [cellData]="fakeCellData" [placeholderSize]="200"></image-with-artifacts>
</div>